export const initNavbar = (): void => {
  const navbar = document.getElementById('navbar');
  const menuBtn = document.getElementById('menu-btn');
  const mobileMenu = document.getElementById('mobile-menu');

  if (!navbar || !menuBtn || !mobileMenu) return;

  const spans = menuBtn.querySelectorAll('span');

  // Scroll effect
  const handleScroll = (): void => {
    if (window.scrollY > 50) {
      navbar.classList.add('navbar-scrolled');
      navbar.classList.remove('py-6');
      navbar.classList.add('py-4');
    } else {
      navbar.classList.remove('navbar-scrolled');
      navbar.classList.remove('py-4');
      navbar.classList.add('py-6');
    }
  };

  // Toggle mobile menu
  const toggleMenu = (): void => {
    const isOpen = mobileMenu.classList.contains('opacity-100');

    if (isOpen) {
      // Close menu
      mobileMenu.classList.remove('opacity-100', 'pointer-events-auto');
      mobileMenu.classList.add('opacity-0', 'pointer-events-none');
      
      // Reset hamburger icon
      spans[0].classList.remove('rotate-45', 'translate-x-[4px]', 'translate-y-[-2px]');
      spans[1].classList.remove('opacity-0', 'scale-x-0');
      spans[2].classList.remove('-rotate-45', 'translate-x-[4px]', 'translate-y-[2px]');
      
      document.body.classList.remove('overflow-hidden');
    } else {
      // Open menu
      mobileMenu.classList.remove('opacity-0', 'pointer-events-none');
      mobileMenu.classList.add('opacity-100', 'pointer-events-auto');
      
      // Transform hamburger to X
      // Since origin-left is set:
      spans[0].classList.add('rotate-45', 'translate-x-[4px]', 'translate-y-[-2px]');
      spans[1].classList.add('opacity-0', 'scale-x-0');
      spans[2].classList.add('-rotate-45', 'translate-x-[4px]', 'translate-y-[2px]');
      
      document.body.classList.add('overflow-hidden');
    }
  };

  // Close mobile menu when clicking on a link
  const closeMenuOnLinkClick = (): void => {
    const mobileLinks = mobileMenu.querySelectorAll('a');
    mobileLinks.forEach(link => {
      link.addEventListener('click', () => {
        if (mobileMenu.classList.contains('opacity-100')) {
          toggleMenu();
        }
      });
    });
  };

  // Listeners
  window.addEventListener('scroll', handleScroll);
  menuBtn.addEventListener('click', toggleMenu);
  
  // Initialize states
  handleScroll();
  closeMenuOnLinkClick();
};
